import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/default/header";
import SubscriptionPackage from "./subscriptionPackage";
import GlobalSidebarMenu from "../default/header/globalSidebarMenu";
import Breadcrumb from "../default/breadcrumb/breadcrumb";


const CardSubscription = () => {
    return (
        <div className="content-wrapper sidebar-menu-enable">
            <Helmet><title>Subscription List - Cardiast</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <GlobalSidebarMenu sidebarTitle="Subscription List"/>
                <div className="content-right">
                    <Breadcrumb />
                    <SubscriptionPackage />
                </div>
            </div>
            
        </div>
    );
}

export default CardSubscription;
